import 'css-chunksrc/client/scenes/project/projectToolsConfiguration/styles.scss';export default {
  "globalSettings": "_globalSettings_1emd9_1",
  "title": "_title_1emd9_8",
  "input": "_input_1emd9_14",
  "label": "_label_1emd9_22",
  "parameters": "_parameters_1emd9_28",
  "parameter": "_parameter_1emd9_28",
  "icon": "_icon_1emd9_39",
  "iconBox": "_iconBox_1emd9_47",
  "name": "_name_1emd9_59",
  "description": "_description_1emd9_65",
  "toggle": "_toggle_1emd9_73",
  "timeSheets": "_timeSheets_1emd9_79"
};